import { $_WC, $_DKD } from '@/confs/common.const';
import commonApi from "@/apis/common.api";

export default {
    // 재난 안전 목록
    fetchSafetyList(q) {
        if(typeof q !== $_WC.UNDEF && q !== '') {
            q = "?dataKdSqno=" + $_DKD.SAFETY + "&" + q;
        } else {
            q = "?dataKdSqno=" + $_DKD.SAFETY;
        }

        return axios.get($_WC.apiBaseURL + "/realtime/safety" + q);
    },

    // 재난 안전 상세
    fetchSafety(registerNo) {
        let url = $_WC.apiBaseURL + "/realtime/safety/" + registerNo  + "?dataKdSqno=" + $_DKD.SAFETY;
        url += "&histDataKdSqno=" + $_DKD.SAFETY_HIST;

        return axios.get(url);
    },

    // 현재 기상 상태
    fetchAirSpace() {
        return axios.get($_WC.apiBaseURL + "/realtime/airSpace");
    },

    // 대기질 예보통보
    fetchAirForecastList() {
        let url = $_WC.apiBaseURL + '/realtime/airForecast?dataKdSqno=' + $_DKD.AIR_FORECAST;
        return axios.get(url);
    },

    // 자치구 대기
    fetchAirGu() {
        return commonApi.fetchMaxBasdtValDataList($_DKD.AIR_GU);
    },

    // 시군구 대기
    fetchAirSgg() {
        return commonApi.fetchMaxBasdtValDataList($_DKD.AIR_SGG);
    },

    // 날씨 예보
    /*
    fetchWeatherForecast(yyyymmdd, hhmm) {
        let url = $_WC.apiBaseURL + "/realtime/weatherForecast?dataKdSqno=" + $_DKD.WEATHER_FORECAST;
        url += "&yyyymmdd=" + yyyymmdd;
        url += "&hhmm=" + hhmm;

        return axios.get(url);
    },
    */

    // 수질 정보 목록
    fetchLatestWaterQualityList() {
        let url = $_WC.apiBaseURL + "/realtime/latestWaterQuality?";
        url += 'waterQualityKdSqno=' + $_DKD.WATER_QUALITY;
        url += '&reservoirKdSqno='  + $_DKD.WATER_RESERVOIR;
        url += '&faucetKdSqno=' +   + $_DKD.WATER_FAUCET;

        return axios.get(url);
    },

    //  물가 정보
    fetchPriceInfo() {
        let url = $_WC.apiBaseURL + "/realtime/priceInfo";
        return axios.get(url);
    }
}
